import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { publicGuard } from './guards/public.guard';
import { LayoutDefault } from './layouts/layout-default/layout-default';
import { LayoutLogout } from './layouts/layout-logout/layout-logout';
import { LayoutMemorial } from './layouts/layout-memorial/layout-memorial';

export const routes: Routes = [
  // public with guards layout-logout
  {
    path: '',
    component: LayoutLogout,
    canActivate: [publicGuard],
    children: [
      {
        path: 'login',
        loadComponent: () => import('./pages/auth/login/login').then((m) => m.Login),
      },
      {
        path: 'signup/success',
        loadComponent: () =>
          import('./pages/auth/signup/signup-success/signup-success').then((m) => m.SignupSuccess),
      },
      {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
      },
    ],
  },
  // public without guards layout-memorial
  {
    path: '',
    component: LayoutMemorial,
    children: [
      {
        path: 'm/:id',
        loadComponent: () =>
          import('./pages/memorials/memorial-public/memorial-public').then(
            (m) => m.MemorialPublic
          ),
      },
      // Products routes
      {
        path: 'products/memorial/customize',
        loadComponent: () =>
          import('./pages/products/memorial-customize/memorial-customize').then(
            (m) => m.MemorialCustomize
          ),
      },
    ],
  },
  // private with guards layout-default
  {
    path: '',
    component: LayoutDefault,
    canActivate: [authGuard],
    children: [
      {
        path: 'memorials',
        loadComponent: () =>
          import('./pages/memorials/memorial-list/memorial-list').then((m) => m.MemorialList),
      },
      {
        path: 'memorials/:id',
        loadComponent: () =>
          import('./pages/memorials/memorial-detail/memorial-detail').then((m) => m.MemorialDetail),
      },
      {
        path: '',
        redirectTo: '/memorials',
        pathMatch: 'full',
      },
    ],
  },
];
